import React from 'react';
import {
  DataGridButton,
  IColumnType,
  IDataType,
  SisDataGridColumns,
} from '../../../components/table';

export const Columns = (
  isReadOnly,
  currency,
  translate,
  handleEdit,
  handleRemove,
): SisDataGridColumns => [
  {
    dataType: IDataType.date,
    dataField: 'accountingDate',
    caption: 'Accounting date',
    cssClass: 'dg-align-right',
    width: '10%',
  },
  {
    dataType: IDataType.string,
    dataField: 'typeName',
    caption: 'Cost type',
    cssClass: 'dg-align-left',
    width: '13%',
  },
  {
    dataType: IDataType.string,
    dataField: 'supplier',
    caption: 'Supplier',
    cssClass: 'dg-align-left',
    width: '17%',
  },
  {
    dataType: IDataType.string,
    dataField: 'description',
    caption: 'Description',
    cssClass: 'dg-align-left',
    width: '25%',
  },
  {
    dataType: IDataType.number,
    dataField: 'amount',
    caption: 'Amount',
    cssClass: 'dg-align-right',
    format: { type: 'fixedPoint', precision: 2 },
    // měna je společná pro celou aplikaci (Config), do záznamu se neukládá
    customizeText: (cellInfo) =>
      currency ? `${cellInfo.valueText} ${currency}` : cellInfo.valueText,
    width: '10%',
  },
  {
    dataType: IDataType.string,
    dataField: 'reference',
    caption: 'Reference',
    cssClass: 'dg-align-left',
    width: '10%',
  },
  {
    dataType: IDataType.number,
    dataField: 'attachmentCount',
    caption: 'Attachments',
    cssClass: 'dg-align-right',
    width: '4%',
  },
  {
    dataType: IDataType.string,
    dataField: 'createdByName',
    caption: 'Created by',
    cssClass: 'dg-align-left',
    width: '10%',
    visible: false,
  },
  {
    dataType: IDataType.dateTime,
    dataField: 'created',
    caption: 'Created',
    cssClass: 'dg-align-right',
    width: '10%',
    visible: false,
  },
  {
    dataType: IDataType.string,
    dataField: 'updatedByName',
    caption: 'Updated by',
    cssClass: 'dg-align-left',
    width: '10%',
    visible: false,
  },
  {
    dataType: IDataType.dateTime,
    dataField: 'updated',
    caption: 'Updated',
    cssClass: 'dg-align-right',
    width: '10%',
    visible: false,
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => {
      if (isReadOnly) return <></>;
      return ButtonCell(data, translate, handleEdit, handleRemove);
    },
    width: '7%',
  },
];

const ButtonCell = (cellData, translate, handleEdit, handleRemove) => {
  return (
    <>
      <DataGridButton
        hint={translate!('Edit', '')}
        icon="edit"
        cellData={cellData}
        onClick={handleEdit}
      />
      <DataGridButton
        hint={translate!('Delete', '')}
        icon="trash"
        cellData={cellData}
        onClick={handleRemove}
      />
    </>
  );
};
